import { lazy } from 'react';

const Statistic = lazy(() => import('./Statistic'));

export { Statistic };
